const getReleaseNotes = (t) => {
  let noteNew = '-';
  if (t) {
    if (t.noteNew !== 'undefined') {
      noteNew = t.noteNew;
    }
  }
  return noteNew;
};
/**
 * Get and assign previous thumbnail if there is no thumbnail in current version.
 * @param {Number} currentVersionIndex current version index.
 * @param {Object} version active version object.
 * @param {Array} versions array of version object.
 */
const getPreviousVersion = (currentVersionIndex, version, versions) => {
  if (version) {
    if (!version.thumbnail) {
      for (let previousIndex = currentVersionIndex + 1; previousIndex <= versions.length; previousIndex++) {
        if (versions[previousIndex] && versions[previousIndex].thumbnail) {
          version.thumbnail = versions[previousIndex].thumbnail;
          break;
        } else {
          version.thumbnail = '';
        }
      }
    }
  }
  return version;
};

const dataURItoBlob = (dataURI) => {
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) { byteString = atob(dataURI.split(',')[1]); } else { byteString = unescape(dataURI.split(',')[1]); }
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeString });
};

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export {
  getReleaseNotes,
  getPreviousVersion,
  dataURItoBlob,
  toBase64
};
